import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProjectStatusCountBlock from "./ProjectStatusCountBlock";
import TaskListCalendar from "./calendars/TaskListCalendar";
import UserTaskList from "./UserTaskList";
import ActivityList from "./ActivityList";
import RadioOptionList from "./RadioOptionList";
import { dateFormat, dateConvertToTimeStamp, dateFormatAccToTimeZone } from "../../services/Util";
import { useSelector } from "react-redux";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import { RotatingLines } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { getLoggedInUserRole, getRangeDates } from "../../services/Util";
import $ from "jquery";
import { ConditionalBlock } from "../../ConditionalBlock";
import classnames from 'classnames';
import { CalendarIcon } from "../../AppIcons";

export default function ProjectTab() {
  const { t } = useTranslation();
  const translate = t;
  const ref = useRef(null);
  var display = "code";
  var uniqueVar = "code";
  const navigate = useNavigate();
  const roleArray = getLoggedInUserRole();
  const [myTasks, setMyTasks] = useState([]);
  const [myTasksCalendar, setMyTasksCalendar] = useState([]);
  const [myTaskCount, setMyTaskCount] = useState(15);
  const [taskTypes, setTaskTypes] = useState([]);
  const [taskDetail, setTaskDetail] = useState([]);
  const [showOptions, setOptions] = useState(false);
  const [activityTotalCount,setActivityTotalCount] = useState(0)
  const [tasksLoader, toggleTaskLoader] = useState(true);
  const [userTasksLoaded, hideUserTaskLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [activities, setActivity] = useState([]);
  const [taskTypeUrl, concatUrl] = useState("empty");
  const [userAlert, setAlertCount] = useState([]);
  const [projectRequestCount, setProjectRequestCount] = useState(0);
  const [projectDiscussion, setProjectDiscussion] = useState(0);
  const [calenderOpen, toggleCalendar] = useState(false);
  const [queryParams, setQueryParams] = useState(new URLSearchParams(window.location.search));
  let param=new URLSearchParams(window.location.search)
  const getPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;


  const openCalendar = () => {
    const newParams = new URLSearchParams(queryParams);
    newParams.set('open-calendar', true);
    setQueryParams(newParams);
    toggleCalendar(true);
  };
  const closeCalandar = () => {
    const newParams = new URLSearchParams(queryParams);
    newParams.set('open-calendar', false);
    setQueryParams(newParams);
    toggleCalendar(false);
  };

  useEffect(() => {
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams}`);
  }, [queryParams]);
 
  useEffect(()=>{
    toggleCalendar(param.get("open-calendar") !==null?param.get("open-calendar"):false )
  },[])

  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;

    const selectedRange = useSelector((CalendarRangeSlice) => CalendarRangeSlice.calendar_range).range;
    const selectedDateRangeRedux = getRangeDates(selectedRange);

  const selectedTaskRedux = useSelector(
    (TaskTypeSelected) => TaskTypeSelected.task_selected
  ).value;

  const startDate = dateFormat(
    selectedDateRangeRedux[0],
    Constants.DATE_FORMAT
  );
  
  const endDate = dateFormat(selectedDateRangeRedux[1], Constants.DATE_FORMAT);

  const followed = useSelector((FollowingSlice) => FollowingSlice.follow).value;

  const SelectedDepartmentRedux = useSelector(
    (SelectDropDownSlice) => SelectDropDownSlice.select_dropdown
  ).value;
  const SelectLanguageRedux = useSelector(
    (languageSelected) => languageSelected.selected_language
  ).value;

  const languageId =
    SelectLanguageRedux !== "" ? `&language=${SelectLanguageRedux}` : "";
    
  const showAllActivityPage = () => {
    navigate('all-activity')
  };

  const selectedTaskData = taskTypes.filter((task) => {
    return task.code === taskDetail[0];
  });

  useEffect(() => {
    let str = ``;
    var arrrayLen = selectedTaskData[0]?.taskTypes?.length;
    if (selectedTaskData[0]?.taskTypes?.length > 0) {
      selectedTaskData[0]?.taskTypes.map((tasks, index) => {
        if (arrrayLen <= selectedTaskData[0]?.taskTypes.length) {
          str += `&type=${tasks.originalEnum}`;
        }
      });
      if(str === taskTypeUrl){
        hideUserTaskLoader(false)
      }
      concatUrl(str);
    }
  }, [selectedTaskData]);

  const showOption = (e) => {
    const targetLabel = e?.target?.closest(".radio-form-check");
    const targetInput = e?.target?.closest(".form-check-input");
    const popupBody = e?.target?.closest("inner-popover");
    
    if (e.type === "click" || e.key === Constants.ENTER) {
      if ($('#circle').attr('aria-expanded')==="true") {
        $('#circle').attr('aria-expanded', "false");
      } else {
        $('#circle').attr('aria-expanded', "true");
      }
    }
    
    if (e.key === Constants.ESCAPE) {
      $('#circle').attr('aria-expanded', "false");
      $('#circle').trigger('focus');
    }
    if (!(targetLabel || targetInput)) {
      if (e.type === "click") {
        showOptions ? setOptions(false) : setOptions(true);
        setTimeout(()=>{
          $('#circle').find('.popover-body input:first').trigger('focus');
        }, 0);
      }
      if (e.type === "keydown" && e.which === 13) {
        showOptions ? setOptions(false) : setOptions(true);
        setTimeout(()=>{
          $('#circle').find('.popover-body input:first').trigger('focus');
        }, 0);
      }
    }
    if (popupBody || targetLabel || targetInput) {
      if (e.type === "keydown" && e.which === 27) {
        setOptions(false);
      }
    }
    if ($(e.target).closest('.group-radio-list div').is(':last-child') &&
        e.key === Constants.TAB && !e.shiftKey) {
          e.preventDefault();
          $(e.target).closest('.group-radio-list').find('div:first-child input').trigger('focus');
    } else if ($(e.target).closest('.group-radio-list div').is(':first-child') &&
        e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          $(e.target).closest('.group-radio-list').find('div:last-child input').trigger('focus');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref?.current?.contains(event?.target)) {
        setOptions(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref]);

  useEffect(() => {
    if (selectedTaskRedux[0] !== undefined) {
      if (selectedTaskRedux[0] === "ALL") {
        concatUrl("");
        setTaskDetail(["All", "All"]);
      } else {
        setTaskDetail(selectedTaskRedux);
      }
      setTimeout(() => {
        setOptions(false);
      }, 1000);
    }
  }, [selectedTaskRedux]);

  useEffect(() => {
    // Add or remove the class from the body element
    document.body.className = classnames({
      // other classes you might have
      'model-open': false, // set to true to add, false to remove
    });

    // Cleanup function
    return () => {
      // Restore the body class to its initial state or remove specific classes
      document.body.className = '';
    };
  }, []);

  useEffect(() => {
    getAxiosResponse(APIUrls.ALL_TASK_TYPES)
      .then((res) => {
        if (res?.data?.data?.result?.length > 0) {
          var taskTypes = res?.data?.data?.result;
          taskTypes.unshift({ display: "ALL", code: "All" });
          setTaskTypes(taskTypes);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    setPage(1);
    var departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";
    if (taskTypeUrl !== "empty") {
      getAxiosResponse(
        APIUrls.ALL_TASKS +
          `?onlyFollowed=${followed}&status=OPEN&groupByTaskType=true&page=1&pageSize=15&mine=true${departmentId}${taskTypeUrl}&startDate=${startDate}&endDate=${endDate}${languageId}&order=${Constants.ASC}&sort=${Constants.DUE_DATE}`
      )
        .then((res) => {
          if (res?.data !== "" && res?.data?.data) {
            hideUserTaskLoader(false);
            setMyTaskCount(res?.data?.data?.resultCount);
            setMyTasks(res?.data?.data?.result);
          } else {
            setMyTasks([]);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [
    startDate,
    endDate,
    SelectedDepartmentRedux,
    taskTypeUrl,
    followed,
    languageId,
  ]);

  const handleTaskViewAll = () => {
    const url = `/task/all`;
    const state = {
      tasktypes: selectedTaskData[0]?.taskTypes?.map((task) => task?.originalEnum),
      mine: true,
      assigneeId: custBootstrapDataRedux?.user?.userId || "",
      assigneeName: "Me",
      status: 'OPEN',
      statusLabel: translate("tasks.tasks.open"),
      taskTypeLabel: taskDetail[1]
    };
    // Open in current tab using navigate
    navigate(url, { state });
  };

  useEffect(() => {
    var departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";
    if (taskTypeUrl !== "empty") {
      getAxiosResponse(
        APIUrls.ALL_TASKS +
          `?onlyFollowed=${followed}&status=OPEN&groupByTaskType=true&page=1&pageSize=${myTaskCount}&mine=true${departmentId}${taskTypeUrl}&startDate=${startDate}&endDate=${endDate}${languageId}&order=${Constants.ASC}&sort=task.${Constants.DUE_DATE}`
      )
        .then((res) => {
          if (res.data !== "") {
            setMyTasksCalendar(res.data.data?.result);
          } else {
            setMyTasksCalendar([]);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [
    calenderOpen,
    startDate,
    endDate,
    SelectedDepartmentRedux,
    taskTypeUrl,
    followed,
    languageId,
  ]);

  useEffect(() => {
    hideUserTaskLoader(true);
    var departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";
    getAxiosResponse(
      APIUrls.ALL_ACTIVITIES +
        `?onlyFollowed=${followed}&startDate=${startDate}&endDate=${endDate}${departmentId}&page=1${languageId}`
    )
      .then((res) => {
        if (res.data.data?.events?.length !== 0) {
          toggleTaskLoader(false);
          setActivityTotalCount(res?.data?.data?.totalCount)
          let activities=res?.data?.data?.events
          let activityData=activityListFun(activities)
          setActivity(activityData);
        } else {
          setActivity([]);
          toggleTaskLoader(false);
        }
        hideUserTaskLoader(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [startDate, endDate, SelectedDepartmentRedux, followed, languageId]);

  useEffect(() => {
    var departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";
    getAxiosResponse(
      APIUrls.ALL_ACTIVITIES +
        `?onlyFollowed=${followed}&startDate=${startDate}&endDate=${endDate}${departmentId}&page=${page}${languageId}`
    )
      .then((res) => {
        if (res?.data?.data?.events && res?.data?.data?.events?.length !== 0) {
          toggleTaskLoader(false);
          if (activities && activities?.length >= 1) {
            let oldId = activities[activities?.length - 1]?.id;
            let newId = res?.data?.data?.events[14]?.id;
            if (newId !== undefined && oldId !== newId) {
              let activities=res?.data?.data?.events
              let activityData=activityListFun(activities)
              setActivity((activities) => [
                ...new Set([...activities, ...activityData]),
              ]);
              toggleTaskLoader(false);
            }
          } else {
            let activities=res?.data?.data?.events
            let activityData=activityListFun(activities)
            setActivity(activityData);
            toggleTaskLoader(false);
          }
        } else {
          setActivity(activities);
          toggleTaskLoader(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [page]);

  let activityListFun = (activities) => {
    if (activities && activities.length > 0) {
      let obj = {};
      let todayList = [];
      let yesterdayList = [];
      
      activities.forEach(data => {
        let groupDate = data?.createdDate.date;
        if (data?.createdDate?.today) {
          todayList.push({ ...data, Today: true, Yesterday: false, pastDate: false });
        } else if (data?.createdDate?.yesterday) {
          yesterdayList.push({ ...data, Today: false, Yesterday: true, pastDate: false });
        } else if (!obj[groupDate]) {
          obj[groupDate] = [data];
        } else {
          obj[groupDate].push(data);
        }
      });
  
      return { Today: todayList, Yesterday: yesterdayList, ...obj };
    }
    return [];
  }


  useEffect(() => {
    const projectId = "&projectId";

    const departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";
    let userAlertCountUrl = `?`;

    const dateTimestamp = dateConvertToTimeStamp();
    if (followed !== null && followed !== undefined) {
      userAlertCountUrl += `onlyFollowed=${followed}`;
    }

    if (departmentId !== "" && departmentId !== undefined) {
      userAlertCountUrl += departmentId;
    }
    userAlertCountUrl += "&_=" + dateTimestamp;
    // ?onlyFollowed=${followed}&_=${dateTimestamp}
    if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(
      APIUrls.USER_ALERT_COUNT +
        `${userAlertCountUrl}${languageId}&startDate=${startDate}&endDate=${endDate}`
    )
      .then((res) => {
        setAlertCount(res?.data?.data);
      })
      .catch((err) => {
        console.error(err);
      });
    }
  }, [startDate, endDate, SelectedDepartmentRedux, followed, languageId]);

  useEffect(() => {
    const departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";

    let projectRequestUrl = `?`;

    const dateTimestamp = dateConvertToTimeStamp();
    if (departmentId !== "" && departmentId !== undefined) {
      projectRequestUrl = projectRequestUrl + departmentId;
    }
    if (startDate !== null && startDate !== undefined) {
      projectRequestUrl = projectRequestUrl + `&startDate=${startDate}`;
    }
    if (endDate !== null && endDate !== undefined) {
      projectRequestUrl = projectRequestUrl + `&endDate=${endDate}`;
    }
    projectRequestUrl = projectRequestUrl + "&_=" + dateTimestamp;
    if(!roleArray.includes('ROLE_VENDOR') && custBootstrapDataRedux?.features?.PROJECT_REQUESTER){
      getAxiosResponse(
        APIUrls.PROJECT_REQUEST_COUNT +
          `${projectRequestUrl}${languageId}&startDate=${startDate}&endDate=${endDate}`
      ).then((res) => {
          setProjectRequestCount(res?.data?.data?.result);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [startDate, endDate, SelectedDepartmentRedux, followed, languageId]);

  useEffect(() => {
    const dateTimestamp = dateConvertToTimeStamp();
    let topicUnreadCount = ``;
    const departmentId =
      SelectedDepartmentRedux !== ""
        ? `&deptId=${SelectedDepartmentRedux}`
        : "";

    if (departmentId !== "" && departmentId !== undefined) {
      topicUnreadCount = topicUnreadCount + departmentId;
    }
    if (followed !== null && followed !== undefined) {
      topicUnreadCount = topicUnreadCount + `&onlyFollowed=${followed}`;
    }

    topicUnreadCount = topicUnreadCount + "&_=" + dateTimestamp;


    if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(
      APIUrls.TOPIC_UNREAD_COUNT +
        `${topicUnreadCount}${languageId}&startDate=${startDate}&endDate=${endDate}`
    )
      .then((res) => {
        setProjectDiscussion(res?.data?.data?.count);
      })
      .catch((err) => {
        console.error(err);
      });
    }
  }, [followed, SelectedDepartmentRedux, languageId, startDate, endDate]);
  const state = {
    projectType:"&projectStatusInError=true"
  };
  return (
    <div className="wrap-data">
      <ul className="project-list flex-center">
        <li>
            <a onClick={()=>navigate("/projects",{state})} onKeyDown={(e)=>{if(e.key===Constants.ENTER){navigate("/projects",{state})}}} className="btn-alert error-alert" tabIndex="0">
              <svg className="error-alert" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.9926 1.46144 6.6994C1.71867 5.40619 2.35361 4.2183 3.28596 3.28595C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6667 8.87548 14.4942 9.74238 14.1592 10.5512C13.8242 11.3601 13.3331 12.095 12.714 12.714C12.095 13.3331 11.3601 13.8242 10.5512 14.1592C9.74239 14.4942 8.87548 14.6667 8 14.6667Z"
                  fill="#FC1F1F"/>
                <path d="M7.99997 9.38006C7.77011 9.38006 7.54967 9.28875 7.38714 9.12622C7.22461 8.96369 7.1333 8.74325 7.1333 8.5134V4.5134C7.1333 4.28354 7.22461 4.0631 7.38714 3.90057C7.54967 3.73804 7.77011 3.64673 7.99997 3.64673C8.22982 3.64673 8.45026 3.73804 8.61279 3.90057C8.77532 4.0631 8.86663 4.28354 8.86663 4.5134V8.5134C8.86663 8.74325 8.77532 8.96369 8.61279 9.12622C8.45026 9.28875 8.22982 9.38006 7.99997 9.38006Z"
                  fill="#FC1F1F"/>
                <path d="M7.9668 12.3467C8.51908 12.3467 8.9668 11.899 8.9668 11.3467C8.9668 10.7944 8.51908 10.3467 7.9668 10.3467C7.41451 10.3467 6.9668 10.7944 6.9668 11.3467C6.9668 11.899 7.41451 12.3467 7.9668 12.3467Z"
                  fill="#FC1F1F" />
              </svg>
              {userAlert?.errorCount} {translate("project_page.errors")}
            </a>
        </li>
        {getPermissions?.includes('ALERTS')? (
        <li>
          <Link to="/alerts" className="btn-alert error-alert" state={{ startDate: startDate , endDate: endDate, onlyFollowed: followed}}>
              <svg className="error-alert" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" >
                <path d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.9926 1.46144 6.6994C1.71867 5.40619 2.35361 4.2183 3.28596 3.28595C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6667 8.87548 14.4942 9.74238 14.1592 10.5512C13.8242 11.3601 13.3331 12.095 12.714 12.714C12.095 13.3331 11.3601 13.8242 10.5512 14.1592C9.74239 14.4942 8.87548 14.6667 8 14.6667Z"
                  fill="#FC1F1F" />
                <path d="M7.99997 9.38006C7.77011 9.38006 7.54967 9.28875 7.38714 9.12622C7.22461 8.96369 7.1333 8.74325 7.1333 8.5134V4.5134C7.1333 4.28354 7.22461 4.0631 7.38714 3.90057C7.54967 3.73804 7.77011 3.64673 7.99997 3.64673C8.22982 3.64673 8.45026 3.73804 8.61279 3.90057C8.77532 4.0631 8.86663 4.28354 8.86663 4.5134V8.5134C8.86663 8.74325 8.77532 8.96369 8.61279 9.12622C8.45026 9.28875 8.22982 9.38006 7.99997 9.38006Z"
                  fill="#FC1F1F" />
                <path d="M7.9668 12.3467C8.51908 12.3467 8.9668 11.899 8.9668 11.3467C8.9668 10.7944 8.51908 10.3467 7.9668 10.3467C7.41451 10.3467 6.9668 10.7944 6.9668 11.3467C6.9668 11.899 7.41451 12.3467 7.9668 12.3467Z"
                  fill="#FC1F1F" />
              </svg>
              {userAlert?.all} {" "}
              {translate("user_alert.alerts")} 
          </Link>
        </li>) : null }
        <ConditionalBlock condition={getPermissions?.includes('PENDING_REQUEST')}>
        <li>
            <Link to="/project-request/list" className="btn-alert warning">
              <span>{projectRequestCount}</span>{" "}
              {translate("project_page.pending_requests")}
            </Link>
        </li>
        </ConditionalBlock>
        
        {getPermissions?.includes('DASHBOARD_DISCUSSION')? (
        <li>
            <Link to="/discussions" className="btn-alert primary">
              <span>{projectDiscussion}</span>{" "}
              {translate("project_page.new_discussions")}
            </Link>
        </li>
        ) : null }
      </ul>

      <div className="inner-dashboard-content flex">
        <div className="left-content">
          <ProjectStatusCountBlock />

          <div className="task-assign-block white-bg">
            <div className="task-assign-heading flex-center" data-tour="task-aasign">
              <div className="flex-left flex-center">
                <h4 id="tablist-1">{translate("project_page.tasks_assigned_to_me")}</h4>
                <strong>{taskDetail[1]}</strong>
              </div>
              <div className="flex-right flex-center">
                <div className="group-btn flex-center" role="tablist" aria-labelledby="tablist-1" aria-busy="true">
                  <button
                    className={
                      calenderOpen
                        ? "dashboard-btn mt-0"
                        : "active dashboard-btn mt-0"
                    }
                    aria-label="List view"
                    aria-current={!calenderOpen && "true"}
                    onClick={closeCalandar}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                  <button
                    className={
                      calenderOpen
                        ? "active dashboard-btn mt-0"
                        : "dashboard-btn mt-0"
                    }
                    aria-label="Calender view"
                    aria-current={calenderOpen && "true"}
                    onClick={openCalendar}
                  >
                   <CalendarIcon/>
                  </button>
                </div>

                <div
                  className="circle"
                  id="circle"
                  role="button"
                  aria-label="Task Type"
                  aria-expanded="false"
                  onClick={(e) => {
                    showOption(e);
                  }}
                  onKeyDown={(e) => {
                    showOption(e);
                  }}
                  tabIndex="0"
                >
                  <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    {showOptions ? (
                      <div
                        style={
                          showOptions
                            ? { display: "block" }
                            : { display: "none" }
                        }
                        className="triangle-with-shadow"
                      ></div>
                    ) : (
                      ""
                    )}
                  </div>
                  {showOptions ? (
                    <div
                      ref={ref}
                      className="popover-body"
                      style={
                        showOptions ? { display: "block" } : { display: "none" }
                      }
                    >
                      <div className="inner-popover" role="radiogroup" aria-labelledby="task_type_1">
                        <h4 id="task_type_1">{translate("project_page.task_type")}</h4>
                        <RadioOptionList
                          selected={taskDetail[0]}
                          taskTypes={taskTypes}
                          parameterToShow={display}
                          display={showOptions}
                          parmToUse={uniqueVar}
                          use="taskList"
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {userTasksLoaded ? (
              <div style={{ textAlign: "center" }}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  width="96"
                  animationDuration="0.75"
                  visible={userTasksLoaded}
                />
              </div>
            ) : (
              <div className="tab-content">
                {calenderOpen ? (
                  <div className="calendar-tab-content">
                    <TaskListCalendar
                      calendarType="US"
                      locale="en"
                      className="dashCalendar"
                      tasks={myTasksCalendar}
                    />
                  </div>
                ) : (
                  <div className="inner-tab-content">
                    {myTasks && myTasks?.length  !==0 ? (
                      myTasks.map((task) => {
                        return <UserTaskList task={task} key={task.id} use="dashboard"/>;
                      })
                    ) : (
                      <div className="no-data-display align-center">
                        <i className="nodata-icon"></i>
                        <p>{Constants.TASK_ASSIGN}</p>
                      </div>
                    )}
                     {myTasks?.length !== 0 && myTaskCount > 5 ? (
                <div className="p-5 text-center">
                  <button className="dashboard-btn" onClick={()=>handleTaskViewAll()}>
                  View all {myTaskCount} tasks
                  </button>
                </div>
              ) : null}
                    <div style={{ textAlign: "center" }}>
                      <RotatingLines
                        strokeColor="grey"
                        strokeWidth="5"
                        width="96"
                        animationDuration="0.75"
                        visible={userTasksLoaded}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {getPermissions.includes('ACTIVITY_FEED')? (
        <div className="right-content" data-tour="activity-feed">
          {userTasksLoaded ? (
            <div style={{ textAlign: "center" }}>
              <RotatingLines
                strokeColor="grey"
                strokeWidth="5"
                width="96"
                animationDuration="0.75"
                visible={true}
              />
            </div>
          ) : (
            <>
            <h4>{translate("project_page.activity_feed")}</h4>
              {activities &&  Object.keys(activities)?.length !== 0 ? (
                  <>
                  {
                    Object.keys(activities).map(data=>
                      <>
                      <div className="text-right"><h4>{activities[data].length > 0? data:""}</h4></div>
                      {
                      activities[data].map((res,index)=>(
                  <ActivityList pastDate={false} activity={res} key={index} />
                    ))
                      }</>
                    )
                  } 
                </>
              ) : (
                <div className="no-data-display align-center">
                  <i className="nodata-icon"></i>
                  <p>{Constants.NO_ACTIVITY_FEED}</p>
                </div>
              )}
              <div style={{ textAlign: "center" }}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  width="96"
                  animationDuration="0.75"
                  visible={tasksLoader}
                />
              </div>
              {activities?.length !== 0 && activityTotalCount > 15 ? (
                <div className="p-5">
                  <button className="dashboard-btn" onClick={showAllActivityPage}>
                    View all activities
                  </button>
                </div>
              ) : null}
            </>
          )}
        </div>
        ) : null }
      </div>
    </div>
  );
}
